module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAbCAYAAABr/T8RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQFJREFUeNpiZACCzs5OBwY6gvLy8gOMQEsNgOzzDPQFiSxAQgDK+QDEF2hsoQHUPgUWJMELwCBwpKWtwNDdD6TA0crEMEAA2ccKQBc10Ng+BawWA3E9nTz8gQWaoBYgu4bWlgLxBoYRBxh9Jr4BBfF9MvVv2JIvEkiORiYK41aAGtnpAND1RBUgwFACFQL7KQnqQVGACEB9QmyZSzWLDSgNPlKD+gEUkwMuMIwCYgsQYI0EyovraWD2RGD9vgFf4jKAVc5UBgfxVQYsaAmlkAoWxgNxAinZ6QOo9UeF5o0DsdlpwEsuB6Br/9OzAPlAw5YG7uwEjRcFajd9CKUXgAADAMFLPBrGkrw/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list.png
// module id = TV/B
// module chunks = 1